// extracted by mini-css-extract-plugin
module.exports = {"root":"IconProfile_root__1DSti"};